import {
  REQUEST_PAGED_PAGES,
  RECEIVE_PAGED_PAGES,
  REQUEST_PAGE,
  RECEIVE_PAGE
} from "actions/page/page.actions";

export default (
  state = {
      pagesAreFetching: false,
      pages: undefined,
      singlePageIsFetching: false,
      singlePage: undefined
  },
  action
) => {
  switch (action.type) {
      case REQUEST_PAGED_PAGES:
          return { ...state, pagesAreFetching: true };
      case RECEIVE_PAGED_PAGES:
          return {
              ...state,
              pagesAreFetching: false,
              pages: action.pages
          };
      case REQUEST_PAGE:
          return { ...state, singlePageIsFetching: true };
      case RECEIVE_PAGE:
          return {
              ...state,
              singlePageIsFetching: false,
              singlePage: action.singlePage
          };
      default:
          return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/pagesReducer.js